import {
    exportarHelper,
    useBuscarHelper,
} from "../../../Commons/Scripts/Utils/webservice-helper.js";
import {
    URL_INVENTARIO_TARJETA,
    URL_ITEMS_GRID_DASHBOARD,
    URL_ITEMS_AUTOCOMPLETE_DASHBOARD,
    URL_INVENTARIO_PROMEDIO_GRAFICO_DASHBOARD,
    URL_ALMACENES,
    URL_BUSCAR_INVENTARIO_PROMEDIO_GRAFICO,
    URL_BUSCAR_INVENTARIO_PROMEDIO_GRAFICO_POR_ITEM, URL_EXPORTAR_ITEMS_GRID
} from '../../../Inventario/Scripts/Utils/constantes.js'
import {
    URL_EXPORTAR_TIENDA_DATAGRID,
    URL_RENTABILIDAD_POR_VENDEDOR_GRAFICO
} from "../../../Facturacion/Scripts/Utils/constantes";

export const useBuscarTarjetasDashboard = (cuerpo) => {
    const url = URL_INVENTARIO_TARJETA;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};
}

export const useBuscarItemsGridDashboard = (cuerpo) => {
    const url = URL_ITEMS_GRID_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return { data, loading, error };
}
export const useBuscarItemsGridAutoComplete = (cuerpo) => {
    const url = URL_ITEMS_AUTOCOMPLETE_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return { data, loading, error };
}
export const useBuscarInventarioPromedioGrafico = (cuerpo) => {
    const url = URL_INVENTARIO_PROMEDIO_GRAFICO_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return { data, loading, error };
}

export const useBuscarAlmacenes = (cuerpo) => {
    const url = URL_ALMACENES;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return { data, loading, error };
}

export const useBuscarInventarioPromedioPorItemGrafico = (cuerpo) => {
    const { data, loading, error } = useBuscarHelper(URL_BUSCAR_INVENTARIO_PROMEDIO_GRAFICO_POR_ITEM,  cuerpo);
    return { data, loading, error };
}
export const exportarItemsGrid = async (cuerpo) => {

    try {
        await exportarHelper(URL_EXPORTAR_ITEMS_GRID, cuerpo);
    } catch (error) {
        console.error("Falló la descarga del reporte:", error);
        alert("Ocurrió un error al generar el reporte. Por favor, intente de nuevo.");
    } finally {
    }
}